import React, { useContext } from 'react';

import MoreOptionsCell from '../../Cards/MoreOptionsCell';
// import ViewReportIcon from '../../Icons/ViewReportIcon';
import { TableContext } from '../TableContext';

interface ViewDetailsProps {
  data?: any;
  sliderCompFn?: (...args: any) => React.ReactNode;
  label?: string;
  width?: string;
  icon?: React.ReactNode;
  conditionalRenderFn?: (...args: any) => boolean;
}

const ViewDetails: React.FC<ViewDetailsProps> = ({
  data,
  sliderCompFn,
  label,
  width,
  icon,
  conditionalRenderFn,
}) => {
  const tableContext = useContext(TableContext);

  const handleClick = () => {
    tableContext?.setShowTableSlider(true);
    tableContext?.setSliderComp(sliderCompFn && sliderCompFn(data));
  };

  if (conditionalRenderFn && conditionalRenderFn(data)) {
    return <></>;
  }

  return (
    <MoreOptionsCell
      icon={icon || <span>sample icon</span>}
      label={label ?? ''}
      onClick={handleClick}
      width={width}
    />
  );
};

export default ViewDetails;
